<template>
    <v-container class="pa-0" >             
        <v-row class="ma-0" justify="center" v-if="otherData">        
            <v-col class="pa-0" lg="3" md="3" sm="6">
                <v-list two-line class="background-2 w100p">
                    <v-list-item>
                        <v-list-item-action>
                            <v-icon color="green">mdi-cash-multiple</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>{{ totalLabel }}</v-list-item-title>
                            <v-list-item-subtitle>{{ total | currency(2) }}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>       
            </v-col>                
            <!-- rimborsi contati a parte, non sommati agli incassi -->
            <v-col class="pa-0" lg="3" md="3" sm="6" v-if="otherData.total_refund !== undefined">
                <v-list two-line class="background-2 w100p">
                    <v-list-item>
                        <v-list-item-action>
                            <v-icon color="deep-orange">mdi-cash-minus</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>{{ refundLabel }}</v-list-item-title>
                            <v-list-item-subtitle>{{ otherData.total_refund | currency(2) }}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-col>
            <v-col class="pa-0" lg="3" md="3" sm="6" v-if="otherData.total_overpayment !== undefined">
                <v-list two-line class="background-2 w100p">
                    <v-list-item>
                        <v-list-item-action>
                            <v-icon color="orange">mdi-cash-refund</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Eccedenze disponibili</v-list-item-title>
                            <v-list-item-subtitle>{{ otherData.total_overpayment | currency(2) }}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

    export default {
        name: 'payments-footer',
        props: {
            items: Array,
            fieldsset: Array,
            otherData: Object,
        },

        data() {
            return {
            }
        },

        computed: {
            total() {
                return this.otherData.total_amount
            },

            // lato fornitori si parla di pagamenti, lato clienti di incassi
            isSupplierSide() {
                return (this.items || []).some(item => item.business === 1 || item.business === '1')
            },
            totalLabel() {
                return this.isSupplierSide ? 'Pagamenti' : 'Incassi'
            },
            refundLabel() {
                return this.isSupplierSide ? 'Rimborsi ricevuti' : 'Rimborsi'
            },
        },
    }
</script>